import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';
import { WHATSAPP_NUMBER } from '../utils/whatsapp';
import './SolicitacoesPage.css';

const formatCpfCnpj = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 14);

  if (digits.length <= 11) {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
  }

  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 12) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
};

const formatPhoneInput = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

const formatCepInput = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

const getFirstName = (value) => {
  const text = String(value || '').trim();
  if (!text) return 'Cliente';
  return text.split(/\s+/)[0] || 'Cliente';
};

const WHATSAPP_SUPORTE_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Preciso validar minha identidade para acessar a área de solicitações.')}`;
const WHATSAPP_FALAR_SUPORTE_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Gostaria de falar com o suporte da Faynet.')}`;

const ASSUNTO_SUPORTE_LABEL = 'Suporte (ID 100)';
const PRIORIDADE_OPTIONS = [
  { value: 'baixa', label: 'Baixa' },
  { value: 'media', label: 'Média' },
  { value: 'alta', label: 'Alta' },
];

const fetchJson = async (url, options) => {
  const response = await fetch(url, options);
  const data = await response.json();
  return { response, data };
};

const buildApiUrl = (baseUrl, params) => {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
};

const formatContractLabel = (contract) => {
  const id = String(contract?.id || '').trim();
  const label = String(contract?.contrato || 'Contrato sem descrição').trim();
  return id ? `${id} - ${label}` : label;
};

const formatChamadoDate = (value) => {
  const text = String(value || '').trim();
  if (!text) return 'Não informado';
  const parsed = new Date(text.replace(' ', 'T'));
  if (Number.isNaN(parsed.getTime())) return text;
  return parsed.toLocaleString('pt-BR');
};

const resolveChamadoStatus = (value) => {
  const raw = String(value || '').trim().toUpperCase();
  const map = {
    F: { label: 'Finalizado', tone: 'finalizado' },
    A: { label: 'Aberto', tone: 'aberto' },
    N: { label: 'Aberto', tone: 'aberto' },
    P: { label: 'Pendente', tone: 'andamento' },
    E: { label: 'Em andamento', tone: 'andamento' },
    C: { label: 'Cancelado', tone: 'cancelado' },
  };

  return map[raw] || { label: raw || 'Sem status', tone: 'neutro' };
};

const IconCheckCircle = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="m8.5 12 2.3 2.3 4.7-4.8" />
  </svg>
);

const IconTicket = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V8Z" />
    <path d="M10 7v10" strokeDasharray="2 2" />
  </svg>
);

const IconSearch = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);

const IconUserEdit = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="10" cy="8" r="3.2" />
    <path d="M4.5 19.5c.6-3.2 3-5 5.5-5 .8 0 1.6.2 2.3.5" />
    <path d="m16.4 14.6 3 3-4.2 4.2H12v-3.2z" />
  </svg>
);

const IconLock = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

const IconInvoice = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 3h9l3 3v15H6z" />
    <path d="M9 9h6M9 13h6M9 17h4" />
  </svg>
);

const IconChat = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z" />
  </svg>
);

const IconPlusBadge = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const IconArrowBadge = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

const MENU_ITEMS = [
  {
    id: 'abrir-chamado',
    label: 'Abrir Chamado',
    description: 'Registre um novo chamado técnico, financeiro ou comercial.',
    icon: IconTicket,
    type: 'form',
  },
  {
    id: 'consultar-chamados',
    label: 'Consultar Chamados',
    description: 'Acompanhe o andamento dos chamados já registrados.',
    icon: IconSearch,
    type: 'form',
  },
  {
    id: 'atualizacao-cadastral',
    label: 'Atualização Cadastral',
    description: 'Atualize telefone, e-mail ou endereço do seu cadastro.',
    icon: IconUserEdit,
    type: 'form',
  },
  {
    id: 'troca-senha',
    label: 'Solicitação de Troca de Senha do Assinante',
    description: 'Altere a sua senha do assinante de forma rápida e segura.',
    icon: IconLock,
    type: 'form',
  },
  {
    id: 'segunda-via',
    label: '2ª Via',
    description: 'Consulte e emita a 2ª via da sua fatura.',
    icon: IconInvoice,
    type: 'link-internal',
    to: '/2via',
  },
  {
    id: 'suporte',
    label: 'Falar com o Suporte',
    description: 'Atendimento direto com um especialista pelo WhatsApp.',
    icon: IconChat,
    type: 'link-external',
    href: WHATSAPP_FALAR_SUPORTE_URL,
  },
];

function SolicitacoesPage() {
  const [step, setStep] = useState('documento');
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [nascimento, setNascimento] = useState('');
  const [telefone, setTelefone] = useState('');
  const [telefoneMascarado, setTelefoneMascarado] = useState('');
  const [clienteNome, setClienteNome] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [panelLoading, setPanelLoading] = useState(false);
  const [chamadoSubmitting, setChamadoSubmitting] = useState(false);
  const [consultaLoading, setConsultaLoading] = useState(false);
  const [openAction, setOpenAction] = useState('');
  const [feedback, setFeedback] = useState({});
  const [clienteContexto, setClienteContexto] = useState(null);
  const [contratosAtivos, setContratosAtivos] = useState([]);
  const [chamadosCliente, setChamadosCliente] = useState([]);
  const [consultaResultado, setConsultaResultado] = useState(null);
  const [chamadoForm, setChamadoForm] = useState({ contractId: '', descricao: '', prioridade: 'media' });
  const [consultaForm, setConsultaForm] = useState({ protocolo: '', periodo: '30' });
  const [cadastralForm, setCadastralForm] = useState({ whatsapp: '', email: '', cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', referencia: '', uf: '' });
  const [senhaForm, setSenhaForm] = useState({ senha: '' });
  const documentoInputRef = useRef(null);
  const menuPanelRef = useRef(null);
  const cadastroFeedbackRef = useRef(null);
  const location = useLocation();
  const pendingActionRef = useRef('');

  useEffect(() => {
    const acao = new URLSearchParams(location.search).get('acao');
    if (acao && MENU_ITEMS.some((item) => item.type === 'form' && item.id === acao)) {
      pendingActionRef.current = acao;
    }
  }, [location.search]);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Área de Solicitações | Faynet';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  useEffect(() => {
    if (step !== 'liberado' || !openAction) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      const panel = menuPanelRef.current;
      if (!panel) {
        return;
      }

      const top = panel.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }, 120);

    return () => window.clearTimeout(timer);
  }, [openAction, step]);

  useEffect(() => {
    const cadastroFeedback = feedback['atualizacao-cadastral'];
    if (!cadastroFeedback || openAction !== 'atualizacao-cadastral') {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      const node = cadastroFeedbackRef.current;
      if (!node) {
        return;
      }

      const top = node.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }, 140);

    return () => window.clearTimeout(timer);
  }, [feedback, openAction]);

  const authUrl = window.MSA_AUTH_URL || 'http://localhost/backend-php/auth.php';

  const resetParaDocumento = () => {
    setStep('documento');
    setCpfCnpj('');
    setNascimento('');
    setTelefone('');
    setTelefoneMascarado('');
    setClienteNome('');
    setMensagem('');
    setError('');
    setOpenAction('');
    setFeedback({});
    setClienteContexto(null);
    setContratosAtivos([]);
    setChamadosCliente([]);
    setConsultaResultado(null);
    setChamadoForm({ contractId: '', descricao: '', prioridade: 'media' });
    setConsultaForm({ protocolo: '', periodo: '30' });
    setCadastralForm({ whatsapp: '', email: '', cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', referencia: '', uf: '' });
    setSenhaForm({ senha: '' });
    window.setTimeout(() => documentoInputRef.current?.focus(), 80);
  };

  const carregarPainel = async (digits, options = {}) => {
    setPanelLoading(true);

    try {
      const [contratosResult, chamadosResult] = await Promise.all([
        fetchJson(buildApiUrl(authUrl, {
          action: 'listar_contratos',
          cpf_cnpj: digits,
        })),
        fetchJson(buildApiUrl(authUrl, {
          action: 'consultar_chamados',
          cpf_cnpj: digits,
          periodo: 'todos',
        })),
      ]);

      const contratosOk = contratosResult.response.ok && contratosResult.data?.success;
      const chamadosOk = chamadosResult.response.ok && chamadosResult.data?.success;

      if (!contratosOk && !chamadosOk) {
        throw new Error(contratosResult.data?.mensagem || chamadosResult.data?.mensagem || 'Não foi possível carregar os dados da área de solicitações.');
      }

      const contratos = contratosOk && Array.isArray(contratosResult.data.contratos) ? contratosResult.data.contratos : [];
      const chamados = chamadosOk && Array.isArray(chamadosResult.data.chamados) ? chamadosResult.data.chamados : [];
      const fallbackContractId = contratos[0]?.id ? String(contratos[0].id) : '';

      setClienteContexto(contratosResult.data?.cliente || chamadosResult.data?.cliente || options.clienteFallback || null);
      setClienteNome(contratosResult.data?.cliente?.nome || chamadosResult.data?.cliente?.nome || options.nomeFallback || '');
      setContratosAtivos(contratos);
      setChamadosCliente(chamados);
      setConsultaResultado(null);
      const dadosCadastrais = contratosResult.data?.dados_cadastrais || {};
      setCadastralForm({
        whatsapp: formatPhoneInput(String(dadosCadastrais.whatsapp || '')),
        email: String(dadosCadastrais.email || ''),
        cep: formatCepInput(String(dadosCadastrais.cep || '')),
        endereco: String(dadosCadastrais.endereco || ''),
        numero: String(dadosCadastrais.numero || ''),
        complemento: String(dadosCadastrais.complemento || ''),
        bairro: String(dadosCadastrais.bairro || ''),
        cidade: String(dadosCadastrais.cidade || ''),
        referencia: String(dadosCadastrais.referencia || ''),
        uf: String(dadosCadastrais.uf || ''),
      });
      const dadosAcesso = contratosResult.data?.dados_acesso || {};
      setSenhaForm({
        senha: String(dadosAcesso.senha || ''),
      });
      setChamadoForm((prev) => ({
        ...prev,
        contractId: contratos.some((item) => String(item.id) === prev.contractId) ? prev.contractId : fallbackContractId,
      }));
    } catch (loadError) {
      setContratosAtivos([]);
      setChamadosCliente([]);
      setConsultaResultado(null);
      setError(loadError.message || 'Não foi possível carregar contratos e chamados agora.');
    } finally {
      setPanelLoading(false);
    }
  };

  const handleConsultar = async (event) => {
    event.preventDefault();

    const digits = cpfCnpj.replace(/\D/g, '');
    if (digits.length !== 11 && digits.length !== 14) {
      setError('Confira o CPF ou CNPJ informado. Digite os 11 ou 14 números.');
      documentoInputRef.current?.focus();
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${authUrl}?action=consultar&cpf_cnpj=${encodeURIComponent(digits)}`);
      const data = await response.json();

      if (!response.ok || !data.success) {
        setError(data.mensagem || 'Não foi possível consultar o cadastro agora.');
        setLoading(false);
        return;
      }

      if (!data.encontrado) {
        setMensagem(data.mensagem || 'Cadastro não encontrado.');
        setStep('nao-encontrado');
        setLoading(false);
        return;
      }

      if (data.metodo === 'data_nascimento') {
        setStep('nascimento');
      } else if (data.metodo === 'whatsapp') {
        setTelefoneMascarado(data.telefone_mascarado || '');
        setStep('whatsapp');
      } else {
        setMensagem(data.mensagem || 'Fale com um especialista para validar sua identidade.');
        setStep('sem-contato');
      }
    } catch {
      setError('Não conseguimos acessar o sistema agora. Tente novamente em instantes.');
    } finally {
      setLoading(false);
    }
  };

  const handleValidar = async (metodo, valor) => {
    setLoading(true);
    setError('');

    try {
      const digits = cpfCnpj.replace(/\D/g, '');
      const response = await fetch(`${authUrl}?action=validar&cpf_cnpj=${encodeURIComponent(digits)}&metodo=${encodeURIComponent(metodo)}&valor=${encodeURIComponent(valor)}`);
      const data = await response.json();

      if (!response.ok || !data.success) {
        setError(data.mensagem || 'Não foi possível validar seus dados agora.');
        setLoading(false);
        return;
      }

      if (data.liberado) {
        setClienteNome(data.cliente?.nome || '');
        setClienteContexto(data.cliente || null);
        setStep('liberado');
        await carregarPainel(digits, {
          nomeFallback: data.cliente?.nome || '',
          clienteFallback: data.cliente || null,
        });
        if (pendingActionRef.current) {
          setOpenAction(pendingActionRef.current);
          pendingActionRef.current = '';
        }
      } else {
        setMensagem(data.mensagem || 'Os dados informados não conferem.');
        setStep('negado');
      }
    } catch {
      setError('Não conseguimos validar seus dados agora. Tente novamente em instantes.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitNascimento = (event) => {
    event.preventDefault();
    if (!nascimento) {
      setError('Informe sua data de nascimento.');
      return;
    }
    handleValidar('data_nascimento', nascimento);
  };

  const handleSubmitTelefone = (event) => {
    event.preventDefault();
    const digits = telefone.replace(/\D/g, '');
    if (digits.length < 10) {
      setError('Informe o número completo do WhatsApp, com DDD.');
      return;
    }
    handleValidar('whatsapp', digits);
  };

  const toggleMenuItem = (id) => {
    setOpenAction((prev) => (prev === id ? '' : id));
  };

  const handleChamadoSubmit = async (event) => {
    event.preventDefault();
    const digits = cpfCnpj.replace(/\D/g, '');

    if (!chamadoForm.contractId) {
      setError('Selecione um contrato ativo para abrir o chamado.');
      return;
    }

    if (!chamadoForm.descricao.trim()) {
      setError('Descreva o que está acontecendo para abrir o chamado.');
      return;
    }

    setChamadoSubmitting(true);
    setError('');

    try {
      const response = await fetch(authUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'abrir_chamado',
          cpf_cnpj: digits,
          contract_id: chamadoForm.contractId,
          prioridade: chamadoForm.prioridade,
          descricao: chamadoForm.descricao,
        }),
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        setError(data.mensagem || 'Não foi possível abrir o chamado agora.');
        return;
      }

      setFeedback((prev) => ({
        ...prev,
        'abrir-chamado': {
          type: 'success',
          title: 'Chamado aberto',
          message: 'Nossa equipe estará verificando sua solicitação e seguirá com o atendimento em breve.',
          protocolo: data.protocolo || data.protocolo_site || '',
        },
      }));
      setChamadoForm((prev) => ({
        contractId: prev.contractId,
        descricao: '',
        prioridade: 'media',
      }));
      await carregarPainel(digits);
    } catch {
      setError('Não conseguimos abrir o chamado agora. Tente novamente em instantes.');
    } finally {
      setChamadoSubmitting(false);
    }
  };

  const handleConsultaSubmit = async (event) => {
    event.preventDefault();
    const digits = cpfCnpj.replace(/\D/g, '');

    setConsultaLoading(true);
    setError('');

    try {
      const response = await fetch(buildApiUrl(authUrl, {
        action: 'consultar_chamados',
        cpf_cnpj: digits,
        protocolo: consultaForm.protocolo.trim(),
        periodo: consultaForm.periodo,
      }));
      const data = await response.json();

      if (!response.ok || !data.success) {
        setError(data.mensagem || 'Não foi possível consultar os chamados agora.');
        return;
      }

      const chamados = Array.isArray(data.chamados) ? data.chamados : [];
      setChamadosCliente(chamados);
      setConsultaResultado({
        items: chamados,
        protocolo: consultaForm.protocolo.trim(),
        periodo: consultaForm.periodo,
      });
      setFeedback((prev) => ({
        ...prev,
        'consultar-chamados': chamados.length > 0
          ? `${chamados.length} chamado(s) encontrado(s).`
          : 'Nenhum chamado encontrado com os filtros informados.',
      }));
    } catch {
      setError('Não conseguimos consultar os chamados agora. Tente novamente em instantes.');
    } finally {
      setConsultaLoading(false);
    }
  };

  const handleCadastralSubmit = async (event) => {
    event.preventDefault();
    const digits = cpfCnpj.replace(/\D/g, '');

    setLoading(true);
    setError('');

    try {
      const response = await fetch(authUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'atualizar_cadastro',
          cpf_cnpj: digits,
          whatsapp: cadastralForm.whatsapp.replace(/\D/g, ''),
          email: cadastralForm.email,
          cep: cadastralForm.cep,
          endereco: cadastralForm.endereco,
          numero: cadastralForm.numero,
          complemento: cadastralForm.complemento,
          bairro: cadastralForm.bairro,
          cidade: cadastralForm.cidade,
          referencia: cadastralForm.referencia,
          uf: cadastralForm.uf,
        }),
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        setError(data.mensagem || 'Não foi possível atualizar o cadastro agora.');
        return;
      }

      setFeedback((prev) => ({
        ...prev,
        'atualizacao-cadastral': {
          type: 'success',
          title: 'Cadastro atualizado',
          message: 'Seus dados de contato e endereco foram atualizados com sucesso na Faynet.',
        },
      }));
      if (data.dados_cadastrais) {
        setCadastralForm({
          whatsapp: formatPhoneInput(String(data.dados_cadastrais.whatsapp || '')),
          email: String(data.dados_cadastrais.email || ''),
          cep: formatCepInput(String(data.dados_cadastrais.cep || '')),
          endereco: String(data.dados_cadastrais.endereco || ''),
          numero: String(data.dados_cadastrais.numero || ''),
          complemento: String(data.dados_cadastrais.complemento || ''),
          bairro: String(data.dados_cadastrais.bairro || ''),
          cidade: String(data.dados_cadastrais.cidade || ''),
          referencia: String(data.dados_cadastrais.referencia || ''),
          uf: String(data.dados_cadastrais.uf || ''),
        });
      }
    } catch {
      setError('Não conseguimos atualizar o cadastro agora. Tente novamente em instantes.');
    } finally {
      setLoading(false);
    }
  };

  const handleSenhaSubmit = async (event) => {
    event.preventDefault();

    const digits = cpfCnpj.replace(/\D/g, '');
    if (!senhaForm.senha.trim()) {
      setError('Informe a senha do assinante.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(authUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'atualizar_senha',
          cpf_cnpj: digits,
          senha: senhaForm.senha,
        }),
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        setError(data.mensagem || 'Não foi possível atualizar a senha do assinante agora.');
        return;
      }

      setSenhaForm({ senha: String(data.dados_acesso?.senha || senhaForm.senha) });
      setFeedback((prev) => ({
        ...prev,
        'troca-senha': {
          type: 'success',
          title: 'Senha atualizada',
          message: 'Senha do assinante atualizada com sucesso.',
        },
      }));
    } catch {
      setError('Não conseguimos atualizar a senha do assinante agora. Tente novamente em instantes.');
    } finally {
      setLoading(false);
    }
  };

  const renderMenuForm = (actionId) => {
    if (actionId === 'abrir-chamado') {
      const chamadoSuccess = typeof feedback['abrir-chamado'] === 'object' ? feedback['abrir-chamado'] : null;

      if (chamadoSuccess) {
        return (
          <div className="solicitacoes-page__success-state" role="status" aria-live="polite">
            <span className="solicitacoes-page__success-state-icon"><IconCheckCircle /></span>
            <strong>{chamadoSuccess.title}</strong>
            <p>Chamado aberto com sucesso. Nossa equipe estará verificando sua solicitação.</p>
            {chamadoSuccess.protocolo && (
              <span className="solicitacoes-page__success-state-protocol">Protocolo {chamadoSuccess.protocolo}</span>
            )}
            <button
              type="button"
              className="solicitacoes-page__link-button"
              onClick={() => {
                setFeedback((prev) => ({ ...prev, 'abrir-chamado': null }));
                setChamadoForm((prev) => ({
                  contractId: prev.contractId || contratosAtivos[0]?.id || '',
                  descricao: '',
                  prioridade: 'media',
                }));
              }}
            >
              Abrir outro chamado
            </button>
          </div>
        );
      }

      return (
        <form className="solicitacoes-page__inline-form" onSubmit={handleChamadoSubmit}>
          <div className="solicitacoes-page__field-row">
            <label>
              Assunto
              <input type="text" value={ASSUNTO_SUPORTE_LABEL} readOnly className="solicitacoes-page__readonly-field" />
            </label>
            <label>
              Contrato
              <select
                value={chamadoForm.contractId}
                onChange={(event) => setChamadoForm((f) => ({ ...f, contractId: event.target.value }))}
                required
                disabled={panelLoading || contratosAtivos.length === 0}
              >
                {contratosAtivos.length === 0 ? (
                  <option value="">Nenhuma fatura em aberto no momento.</option>
                ) : (
                  contratosAtivos.map((contract) => (
                    <option key={String(contract.id)} value={String(contract.id)}>
                      {formatContractLabel(contract)}
                    </option>
                  ))
                )}
              </select>
            </label>
          </div>
          <div className="solicitacoes-page__field-row">
            <label>
              Prioridade
              <select
                value={chamadoForm.prioridade}
                onChange={(event) => setChamadoForm((f) => ({ ...f, prioridade: event.target.value }))}
              >
                {PRIORIDADE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </label>
          </div>
          <label>
            Descrição
            <textarea
              rows={4}
              value={chamadoForm.descricao}
              onChange={(event) => setChamadoForm((f) => ({ ...f, descricao: event.target.value }))}
              placeholder="Descreva com detalhes o que está acontecendo"
              required
            />
          </label>
          <button type="submit" disabled={chamadoSubmitting || panelLoading || contratosAtivos.length === 0}>
            {chamadoSubmitting ? 'Abrindo chamado...' : 'Registrar chamado'}
          </button>
        </form>
      );
    }

    if (actionId === 'consultar-chamados') {
      return (
        <form className="solicitacoes-page__inline-form" onSubmit={handleConsultaSubmit}>
          <label>
            Número do protocolo (opcional)
            <input
              type="text"
              value={consultaForm.protocolo}
              onChange={(event) => setConsultaForm((f) => ({ ...f, protocolo: event.target.value }))}
              placeholder="Ex.: #12345"
            />
          </label>
          <label>
            Período
            <select
              value={consultaForm.periodo}
              onChange={(event) => setConsultaForm((f) => ({ ...f, periodo: event.target.value }))}
            >
              <option value="7">Últimos 7 dias</option>
              <option value="30">Últimos 30 dias</option>
              <option value="todos">Todos</option>
            </select>
          </label>
          <button type="submit" disabled={consultaLoading}>
            {consultaLoading ? 'Consultando...' : 'Consultar'}
          </button>
          {feedback['consultar-chamados'] && (
            <p className="solicitacoes-page__inline-feedback">{feedback['consultar-chamados']}</p>
          )}
          {consultaResultado && (
            <div className="solicitacoes-page__tickets-list">
              {consultaResultado.items.length === 0 ? (
                <p className="solicitacoes-page__muted">Nenhum chamado encontrado para os filtros aplicados.</p>
              ) : (
                consultaResultado.items.map((item, index) => (
                  <article key={`${item.id || item.protocolo || 'ticket'}-${index}`} className={`solicitacoes-page__ticket-card solicitacoes-page__ticket-card--${resolveChamadoStatus(item.status).tone}`}>
                    <div className="solicitacoes-page__ticket-head">
                      <strong>Chamado {item.protocolo || item.id || 'Sem protocolo'}</strong>
                      <span className={`solicitacoes-page__ticket-badge solicitacoes-page__ticket-badge--${resolveChamadoStatus(item.status).tone}`}>
                        {resolveChamadoStatus(item.status).label}
                      </span>
                    </div>
                    <p><strong>Assunto:</strong> {String(item.id_assunto || '100')}</p>
                    <p><strong>Prioridade:</strong> {String(item.prioridade || 'Não informada')}</p>
                    <p><strong>Abertura:</strong> {formatChamadoDate(item.data_abertura || item.ultima_atualizacao || '')}</p>
                    <p><strong>Descrição:</strong> {String(item.mensagem || 'Sem descrição')}</p>
                  </article>
                ))
              )}
            </div>
          )}
        </form>
      );
    }

    if (actionId === 'atualizacao-cadastral') {
      const cadastroSuccess = typeof feedback['atualizacao-cadastral'] === 'object' ? feedback['atualizacao-cadastral'] : null;

      return (
        <form className="solicitacoes-page__inline-form" onSubmit={handleCadastralSubmit}>
          <div className="solicitacoes-page__field-row">
            <label>
              WhatsApp
              <input
                type="tel"
                value={cadastralForm.whatsapp}
                onChange={(event) => setCadastralForm((f) => ({ ...f, whatsapp: formatPhoneInput(event.target.value) }))}
                placeholder="(21) 98765-4321"
                required
              />
            </label>
            <label>
              E-mail
              <input
                type="email"
                value={cadastralForm.email}
                onChange={(event) => setCadastralForm((f) => ({ ...f, email: event.target.value }))}
                placeholder="seuemail@exemplo.com"
                required
              />
            </label>
          </div>
          <div className="solicitacoes-page__field-row">
            <label>
              CEP
              <input
                type="text"
                inputMode="numeric"
                value={cadastralForm.cep}
                onChange={(event) => setCadastralForm((f) => ({ ...f, cep: formatCepInput(event.target.value) }))}
                placeholder="00000-000"
                required
              />
            </label>
            <label>
              UF
              <input
                type="text"
                value={cadastralForm.uf}
                onChange={(event) => setCadastralForm((f) => ({ ...f, uf: event.target.value.toUpperCase().slice(0, 2) }))}
                placeholder="RJ"
              />
            </label>
          </div>
          <div className="solicitacoes-page__field-row solicitacoes-page__field-row--address">
            <label>
              Endereço
              <input
                type="text"
                value={cadastralForm.endereco}
                onChange={(event) => setCadastralForm((f) => ({ ...f, endereco: event.target.value }))}
                placeholder="Rua Teste"
                required
              />
            </label>
            <label>
              Número
              <input
                type="text"
                value={cadastralForm.numero}
                onChange={(event) => setCadastralForm((f) => ({ ...f, numero: event.target.value }))}
                placeholder="1200"
                required
              />
            </label>
          </div>
          <div className="solicitacoes-page__field-row solicitacoes-page__field-row--address">
            <label>
              Complemento
              <input
                type="text"
                value={cadastralForm.complemento}
                onChange={(event) => setCadastralForm((f) => ({ ...f, complemento: event.target.value }))}
                placeholder="Opcional"
              />
            </label>
            <label>
              Bairro
              <input
                type="text"
                value={cadastralForm.bairro}
                onChange={(event) => setCadastralForm((f) => ({ ...f, bairro: event.target.value }))}
                placeholder="Seu bairro"
                required
              />
            </label>
          </div>
          <div className="solicitacoes-page__field-row solicitacoes-page__field-row--address">
            <label>
              Cidade
              <input
                type="text"
                value={cadastralForm.cidade}
                onChange={(event) => setCadastralForm((f) => ({ ...f, cidade: event.target.value }))}
                placeholder="ID da cidade no IXC"
                required
              />
            </label>
            <label>
              Referência
              <input
                type="text"
                value={cadastralForm.referencia}
                onChange={(event) => setCadastralForm((f) => ({ ...f, referencia: event.target.value }))}
                placeholder="Ponto de referência"
              />
            </label>
          </div>
          <button type="submit" disabled={loading}>{loading ? 'Atualizando...' : 'Atualizar cadastro'}</button>
          {cadastroSuccess && (
            <div ref={cadastroFeedbackRef} className="solicitacoes-page__success-inline" role="status" aria-live="polite">
              <span className="solicitacoes-page__success-inline-icon"><IconCheckCircle /></span>
              <div>
                <strong>{cadastroSuccess.title}</strong>
                <p>{cadastroSuccess.message}</p>
              </div>
            </div>
          )}
        </form>
      );
    }

    if (actionId === 'troca-senha') {
      const senhaSuccess = typeof feedback['troca-senha'] === 'object' ? feedback['troca-senha'] : null;

      return (
        <form className="solicitacoes-page__inline-form" onSubmit={handleSenhaSubmit}>
          <label>
            Senha do assinante
            <input
              type="text"
              value={senhaForm.senha}
              onChange={(event) => setSenhaForm((f) => ({ ...f, senha: event.target.value }))}
              placeholder="Digite a senha do assinante"
              required
            />
          </label>
          <button type="submit" disabled={loading}>{loading ? 'Salvando...' : 'Salvar senha'}</button>
          {senhaSuccess && (
            <div className="solicitacoes-page__success-inline" role="status" aria-live="polite">
              <span className="solicitacoes-page__success-inline-icon"><IconCheckCircle /></span>
              <div>
                <strong>{senhaSuccess.title}</strong>
                <p>{senhaSuccess.message}</p>
              </div>
            </div>
          )}
        </form>
      );
    }

    return null;
  };

  const openFormItem = MENU_ITEMS.find((item) => item.type === 'form' && item.id === openAction);
  const exibicaoChamados = consultaResultado?.items || chamadosCliente;

  return (
    <div className="solicitacoes-page">
      <section className="solicitacoes-page__hero">
        <div className={`solicitacoes-page__shell ${step === 'liberado' ? 'solicitacoes-page__shell--wide' : ''}`}>
          <div className="solicitacoes-page__header">
            <span className="solicitacoes-page__eyebrow">Faynet</span>
            <h1>Área de Solicitações</h1>
            <p>Confirme sua identidade para abrir chamados, consultar solicitações e falar com nossa equipe.</p>
          </div>

          <div className="solicitacoes-page__card">
            {step === 'documento' && (
              <form className="solicitacoes-page__form" onSubmit={handleConsultar}>
                <label htmlFor="doc-cpf-cnpj">Digite seu CPF ou CNPJ para começar</label>
                <input
                  id="doc-cpf-cnpj"
                  ref={documentoInputRef}
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  placeholder="000.000.000-00 ou 00.000.000/0000-00"
                  value={cpfCnpj}
                  onChange={(event) => {
                    setCpfCnpj(formatCpfCnpj(event.target.value));
                    if (error) setError('');
                  }}
                  aria-invalid={Boolean(error)}
                  aria-describedby={error ? 'solicitacoes-error' : undefined}
                />
                <button type="submit" disabled={loading} className={loading ? 'is-loading' : ''}>
                  {loading ? <span className="button-loader" aria-label="Consultando" /> : 'Continuar'}
                </button>
              </form>
            )}

            {step === 'nascimento' && (
              <form className="solicitacoes-page__form" onSubmit={handleSubmitNascimento}>
                <p className="solicitacoes-page__step-text">Para confirmar sua identidade, informe sua data de nascimento.</p>
                <label htmlFor="doc-nascimento">Data de nascimento</label>
                <input
                  id="doc-nascimento"
                  type="date"
                  value={nascimento}
                  onChange={(event) => {
                    setNascimento(event.target.value);
                    if (error) setError('');
                  }}
                />
                <button type="submit" disabled={loading} className={loading ? 'is-loading' : ''}>
                  {loading ? <span className="button-loader" aria-label="Validando" /> : 'Confirmar'}
                </button>
                <button type="button" className="solicitacoes-page__link-button" onClick={resetParaDocumento}>
                  Voltar
                </button>
              </form>
            )}

            {step === 'whatsapp' && (
              <form className="solicitacoes-page__form" onSubmit={handleSubmitTelefone}>
                <p className="solicitacoes-page__step-text">
                  Encontramos um WhatsApp cadastrado: <strong>{telefoneMascarado}</strong>.
                  Confirme o número completo para validar sua identidade.
                </p>
                <label htmlFor="doc-telefone">Número completo do WhatsApp</label>
                <input
                  id="doc-telefone"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="off"
                  placeholder="(21) 98765-4321"
                  value={telefone}
                  onChange={(event) => {
                    setTelefone(formatPhoneInput(event.target.value));
                    if (error) setError('');
                  }}
                />
                <button type="submit" disabled={loading} className={loading ? 'is-loading' : ''}>
                  {loading ? <span className="button-loader" aria-label="Validando" /> : 'Confirmar'}
                </button>
                <button type="button" className="solicitacoes-page__link-button" onClick={resetParaDocumento}>
                  Voltar
                </button>
              </form>
            )}

            {step === 'sem-contato' && (
              <div className="solicitacoes-page__result">
                <h2>Fale com um especialista</h2>
                <p>{mensagem}</p>
                <a className="solicitacoes-page__whatsapp-button" href={WHATSAPP_SUPORTE_URL} target="_blank" rel="noopener noreferrer">
                  Chamar no WhatsApp
                </a>
                <button type="button" className="solicitacoes-page__link-button" onClick={resetParaDocumento}>
                  Voltar ao início
                </button>
              </div>
            )}

            {step === 'nao-encontrado' && (
              <div className="solicitacoes-page__result">
                <h2>Cadastro não encontrado</h2>
                <p>{mensagem}</p>
                <button type="button" onClick={resetParaDocumento}>Tentar novamente</button>
              </div>
            )}

            {step === 'negado' && (
              <div className="solicitacoes-page__result solicitacoes-page__result--bad">
                <h2>Acesso não liberado</h2>
                <p>{mensagem}</p>
                <p className="solicitacoes-page__muted">Fale com nosso suporte para validar sua identidade.</p>
                <a className="solicitacoes-page__whatsapp-button" href={WHATSAPP_SUPORTE_URL} target="_blank" rel="noopener noreferrer">
                  Chamar no WhatsApp
                </a>
                <button type="button" className="solicitacoes-page__link-button" onClick={resetParaDocumento}>
                  Tentar novamente
                </button>
              </div>
            )}

            {step === 'liberado' && (
              <div className="solicitacoes-page__result solicitacoes-page__result--ok">
                <h2>Olá, {getFirstName(clienteNome)}!</h2>
                <p>Seu cadastro foi localizado. Escolha como deseja continuar:</p>

                {panelLoading && <p className="solicitacoes-page__muted">Carregando seus contratos e chamados...</p>}
                {!panelLoading && contratosAtivos.length === 0 && (
                  <p className="solicitacoes-page__muted">Nenhum contrato ativo foi carregado no momento. Tente abrir a área novamente em instantes.</p>
                )}

                <div className="solicitacoes-page__menu">
                  {MENU_ITEMS.map((item) => {
                    const Icon = item.icon;
                    const isOpen = openAction === item.id;

                    if (item.type === 'link-internal') {
                      return (
                        <Link key={item.id} to={item.to} className="solicitacoes-page__menu-item">
                          <span className="solicitacoes-page__menu-badge solicitacoes-page__menu-badge--link">
                            <IconArrowBadge />
                          </span>
                          <span className="solicitacoes-page__menu-icon"><Icon /></span>
                          <span className="solicitacoes-page__menu-text">
                            <strong>{item.label}</strong>
                            <span>{item.description}</span>
                          </span>
                        </Link>
                      );
                    }

                    if (item.type === 'link-external') {
                      return (
                        <a key={item.id} href={item.href} target="_blank" rel="noopener noreferrer" className="solicitacoes-page__menu-item">
                          <span className="solicitacoes-page__menu-badge solicitacoes-page__menu-badge--link">
                            <IconArrowBadge />
                          </span>
                          <span className="solicitacoes-page__menu-icon"><Icon /></span>
                          <span className="solicitacoes-page__menu-text">
                            <strong>{item.label}</strong>
                            <span>{item.description}</span>
                          </span>
                        </a>
                      );
                    }

                    return (
                      <button
                        key={item.id}
                        type="button"
                        className={`solicitacoes-page__menu-item ${isOpen ? 'is-open' : ''}`}
                        aria-expanded={isOpen}
                        onClick={() => toggleMenuItem(item.id)}
                      >
                        <span className="solicitacoes-page__menu-badge">
                          <IconPlusBadge />
                        </span>
                        <span className="solicitacoes-page__menu-icon"><Icon /></span>
                        <span className="solicitacoes-page__menu-text">
                          <strong>{item.label}</strong>
                          <span>{item.description}</span>
                        </span>
                      </button>
                    );
                  })}
                </div>

                {/* O formulário do item selecionado sempre aparece abaixo de todos os quadradinhos */}
                {openFormItem && (
                  <div ref={menuPanelRef} className="solicitacoes-page__menu-panel">
                    {renderMenuForm(openFormItem.id)}
                  </div>
                )}

                <button type="button" className="solicitacoes-page__link-button" onClick={resetParaDocumento}>
                  Sair
                </button>
              </div>
            )}

            {error && (
              <div id="solicitacoes-error" className="solicitacoes-page__message solicitacoes-page__message--error" role="alert">
                {error}
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default SolicitacoesPage;
